type CsvJson = {
  headers: string[];
  body: string[][];
};

const STAFF_ATTENDANCE_HEADERS: string[] = [
  'Employee Code',
  'Email',
  'AttendanceDate',
  'InTime',
  'OutTime'
];

const getStaffAttendanceSampleBody = (): string[][] => {
  return [
    ['1033', 'test@test.com', '15-04-2026', '09:00', '18:00'],
    ['1033', 'test@test.com', '16-04-2026', '09:00', '18:00']
  ];
};

const getStaffAttendanceSample = (): CsvJson => ({
  headers: STAFF_ATTENDANCE_HEADERS,
  body: getStaffAttendanceSampleBody()
});

export { getStaffAttendanceSample };
